import React from 'react'

import I18n from 'APP/I18n'
import Modal from 'APP/Components/Modal'

interface OnboardingExitModalProps {
  visible: boolean
  onQuit: () => void
  onCancel: () => void
}

export const OnboardingExitModal = ({ visible, onQuit, onCancel }: OnboardingExitModalProps) => (
  <Modal
    statusBarTranslucent
    visible={visible}
    transparent
    title={I18n.t('OnboardingExitModal.title')}
    subtitle={I18n.t('OnboardingExitModal.subtitle')}
    primaryActionText={I18n.t('OnboardingExitModal.exit')}
    secondaryActionText={I18n.t('OnboardingExitModal.stay')}
    handleCloseModal={onCancel}
    handlePrimaryAction={onQuit}
    handleSecondaryAction={onCancel}
    testID="ONBOARDING_EXIT_MODAL"
  />
)
